import { render } from "./gpuMiner.vue?vue&type=template&id=407ac19a&scoped=true"
import script from "./gpuMiner.vue?vue&type=script&lang=js"
export * from "./gpuMiner.vue?vue&type=script&lang=js"

import "./gpuMiner.vue?vue&type=style&index=0&id=407ac19a&lang=scss&scoped=true"
import "./gpuMiner.vue?vue&type=style&index=1&id=407ac19a&lang=css"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407ac19a"]])

export default __exports__